import { useTranslation } from 'react-i18next';
import './idioma.component.scss';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    function toggleLanguage() {
        const nextLang = i18n.language === 'pt-BR' ? 'en' : 'pt-BR';
        i18n.changeLanguage(nextLang);
        localStorage.setItem('app_language', nextLang);
    }

    const isPT = i18n.language === 'pt-BR';

    return (
        <div className="language-switcher-mmo">
            <div
                className={`toggle ${isPT ? 'pt' : 'en'}`}
                onClick={toggleLanguage}
            >
                <div className="slider" />

                <div className="option left">
                    🇧🇷 <span>PT</span>
                </div>

                <div className="option right">
                    🇺🇸 <span>EN</span>
                </div>
            </div>
        </div>
    );
};

export default LanguageSwitcher;
